import s from './SeachedProducts.module.scss';
import useIsAuth from 'sdk/hooks/useIsAuth';
import ProductCard from '../ProductsByCategory/ProductCard';
import useGetProductBySearch from 'sdk/hooks/shop/useGetProductBySearch';
import { normalizeProduct } from '../ProductsByCategory/ProductsByCategory';

const SeachedProducts = ({ searchText }) => {
  const { data: isAuthData } = useIsAuth();
  const userId = isAuthData?.user?.id;
  const { data: products, isLoading } = useGetProductBySearch(searchText);

  return (
    <div className={s.container}>
      <div className={s.products}>
        {isLoading ? (
          <div className={s.loading}>Loading...</div>
        ) : (
          <div className={s.grid}>
            {products?.length ? (
              products?.map(product => (
                <ProductCard key={product.id} product={normalizeProduct(product)} userId={userId} />
              ))
            ) : (
              <>Not found</>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SeachedProducts;
